import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { RequestService } from '../request/request';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';
import { Territory, TerritoryDTO } from '../../models/territory.interface';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class TerritoryService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'territories/';
  url = environment.service_1 + 'all-territories/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedterritory = new BehaviorSubject<Territory | null>(null);
  selectedterritory$ = this.selectedterritory.asObservable();

  private territories = new BehaviorSubject<Territory[]>([]);
  territories$ = this.territories.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setTerritory(territory: Territory) {
    this.selectedterritory.next(territory);
  }

  setTerritories(territories: Territory[]) {
    this.territories.next(territories);
  }

  removeTerritorySelected() {
    this.selectedterritory.next(null);
  }

  createTerritory(territory: TerritoryDTO) {
    return this.http.post<Territory>(this.urlPath, territory).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateTerritory(id: number, territory: TerritoryDTO & { id: number }) {
    return this.http.put<Territory>(this.urlPath + id + '/', territory).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getTerritory(query: QueryGet): Observable<Pagination<Territory[]>> {
    return this.requestService.get<Territory[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getTerritories(): Observable<Territory[]> {
    return this.http.get<Territory[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionTerritory(territory: Territory[]): OptionSelect[] {
    return territory.map((item: Territory) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
